import styles from './style.module.css';

const PreLoader = () => {
    return (
        <>
            <div className={styles.loader_container}>
                <div className={styles.spinner}></div>
            </div>
        </>
    );
}

export default PreLoader;